import { render, staticRenderFns } from "./BaseFeedbackScreen.vue?vue&type=template&id=56d2a61c&"
import script from "./BaseFeedbackScreen.vue?vue&type=script&lang=js&"
export * from "./BaseFeedbackScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports